/**
 * API configuration utility
 * Ensures API endpoint is explicitly configured to prevent accidental prod/dev mixing
 */

/**
 * Get the API endpoint URL
 * Throws error if not configured (prevents silent fallback to wrong environment)
 */
export function getApiUrl(): string {
  // In development mode (Vite dev server), use proxy
  if (import.meta.env.DEV) {
    return '/api';
  }

  // In production build, require explicit configuration
  const apiEndpoint = import.meta.env.VITE_API_ENDPOINT;
  
  if (!apiEndpoint) {
    throw new Error(
      'VITE_API_ENDPOINT is not configured. ' +
      'Please set VITE_API_ENDPOINT in .env.production or .env.development file. ' +
      'This prevents accidental connection to wrong environment.'
    );
  }

  return apiEndpoint;
}

/**
 * Get the API key
 * Returns null if not configured (some endpoints don't require it)
 */
export function getApiKey(): string | null {
  return import.meta.env.VITE_API_KEY || null;
}
